/* eslint-disable */
import { useCallback, useEffect, useRef, useState } from 'react';

// import IMAGES_WEDDING from '../../resource/wedding/images/_index';

// import Templates from '../events/components/Templates';
import { useParams, useNavigate } from 'react-router-dom';

import PAGE from '../../../../config/path.route';

import EventsService from '../../../events/Events.service';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import InputBasic from '../../../../components/InputBasic/InputBasic';
import { FaInfoCircle, FaTimes, FaSave } from 'react-icons/fa';
import PublishInfoPartyService from '../publish.partyinfo/PublishInfoParty.service';
import ToastNotify from '../../../../utils/Toast';
import Loading from './components/Loading';
import Regex from '../../../../utils/Regex';
import Products from '../publish.news/products/Products';
import TimelineShortcutMenu from '../../components/TimelineShortcutMenu';
import Blank from './components/Blank';
import QuestionTitle from '../publish.question/QuestionTitle';
import Header from '../publish.sub/components/Header';
import { useSelector } from 'react-redux';

export default function PublishDress() {
    const navigate = useNavigate();
    const { eventId } = useParams();
    const [loading, setLoading] = useState(false);
    const [event, setEvent] = useState();
    const [isEdit, setIsEdit] = useState(false);
    const [check, setCheck] = useState(false);
    const { loggedIn } = useSelector((state) => state.auth);
    const formik = useFormik({
        initialValues: {
            dress_1: '',
            dress_2: '',
        },
    });
    useEffect(() => {
        setLoading(true);
        if (eventId) {
            EventsService.getOneEventById(eventId)
                .then(({ data }) => {
                    setEvent(data);
                    formik.setValues({
                        dress_1: data?.form_data?.dress_1 ? data?.form_data?.dress_1 : '',
                        dress_2: data?.form_data?.dress_2 ? data?.form_data?.dress_2 : '',
                    });
                })
                .catch((error) => {
                    console.log(error);
                    const AuthorizeError = 404;
                    if (error.status === AuthorizeError) {
                        navigate(PAGE.dashboard);
                    }
                    const ServerError = 500;
                    if (error.status === ServerError) {
                        navigate(PAGE.dashboard);
                    }
                })
                .finally(() => {
                    setTimeout(() => {
                        setLoading(false);
                    }, 500);
                });
        }
    }, []);

    const handleSubmit = () => {
        console.log('ham submit');
        setCheck(true);
        if (!formik.errors.dress_1 && !formik.errors.dress_1) {
            PublishInfoPartyService.submitForm(event._id, createPayload()).then(({}) => {
                // setFormData(parseJsonData(data?.form_data));
                setIsEdit(false);
                ToastNotify.Success('Lưu thành công!');
            });
        }
    };

    const createPayload = () => {
        const payload = [
            { key: 'dress_1', value: formik.values.dress_1 },
            { key: 'dress_2', value: formik.values.dress_2 },
        ];
        return payload;
    };

    useEffect(() => {
        if (!loggedIn) {
            const beforeUnload = (event) => {
                event.preventDefault();
                event.returnValue = true;
            };
            window.addEventListener('beforeunload', beforeUnload);
            return () => {
                window.removeEventListener('beforeunload', beforeUnload);
            };
        }
    }, []);

    return (
        <>
            <div className="flex flex-col items-center gap-[1.5rem] pb-[2rem] relative">
                {!event?.isExpired && (
                    <div
                        className={
                            (isEdit ? 'bottom-0 opacity-100' : '-bottom-80 opacity-0') +
                            ' fixed inset-x-0 z-[40] bg-gray-50 transition-all duration-500 md:px-6 lg:z-[40]'
                        }
                    >
                        <div className="flex items-center justify-between gap-3 border-t border-gray-300 px-6 py-4 md:px-0">
                            <p>Chưa lưu !</p>
                            <div className="flex gap-3">
                                <button
                                    type="button"
                                    className={
                                        'mx-auto items-center gap-2 inline-flex select-none rounded-md bg-blue-100 px-6 py-2 text-center font-semibold text-blue-500 transition-all duration-150 ease-linear hover:bg-blue-200 '
                                    }
                                    onClick={() => {
                                        setIsEdit(false);
                                    }}
                                >
                                    <FaTimes />
                                    Hủy bỏ
                                </button>
                                <button
                                    // type="submit"
                                    onClick={handleSubmit}
                                    className={
                                        'mx-auto items-center gap-2 inline-flex select-none rounded-md bg-blue-500 px-6 py-2 text-center font-semibold text-white transition-all duration-150 ease-linear hover:bg-blue-600 '
                                    }
                                >
                                    <FaSave />
                                    Hoàn tất
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                <Header event={event} isExpired={event?.isExpired} />
                <div className=" w-full flex justify-evenly mt-20">
                    <div className="lg:flex hidden relative w-[250px]">
                        <TimelineShortcutMenu screen={'dress'} />
                    </div>

                    {loading ? (
                        <Loading />
                    ) : (
                        <div className="w-[100vw] rounded-lg border-[1px] border-slate-200 bg-white-box shadow-lg lg:w-[48rem] 2xl:w-[60rem] flex flex-col">
                            <div className="w-full p-2 px-3 border-b border-gray-300 flex flex-col">
                                <p className="text-black font-bold text-lg mb-1">Trang phục</p>
                            </div>
                            <div className="w-full p-4">
                                <div className="w-full p-4">
                                    <div className="mb-3 w-fit grow text-sm font-medium text-gray-900">
                                        Lưu ý 1:
                                    </div>
                                    <input
                                        placeholder={'VD: "Nam: Vest tối màu, sơ mi trắng, quần âu'}
                                        className="block mt-2 w-full rounded-[0.375rem] border border-gray-300 bg-white disabled:bg-gray-100 p-3 text-sm text-blueGray-600 transition-all duration-150 ease-linear placeholder:text-blueGray-300 focus:outline-none focus:ring-1"
                                        name="dress_1"
                                        type="text"
                                        disable={event?.isExpired}
                                        value={formik.values.dress_1}
                                        onInput={(e) => {
                                            setIsEdit(true);
                                            formik.handleChange(e);
                                        }}
                                    />
                                </div>
                                <div className="w-full p-4">
                                    <div className="mb-3 w-fit grow text-sm font-medium text-gray-900">
                                        Lưu ý 2:
                                    </div>
                                    <input
                                        placeholder={'VD: "Nữ: Váy đầm dạ hộ, áo dài'}
                                        className="block mt-2 w-full rounded-[0.375rem] border border-gray-300 bg-white disabled:bg-gray-100 p-3 text-sm text-blueGray-600 transition-all duration-150 ease-linear placeholder:text-blueGray-300 focus:outline-none focus:ring-1"
                                        name="dress_2"
                                        type="text"
                                        disable={event?.isExpired}
                                        value={formik.values.dress_2}
                                        onInput={(e) => {
                                            setIsEdit(true);
                                            formik.handleChange(e);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="lg:flex hidden relative w-[250px]">
                        <Products />
                    </div>
                </div>
            </div>
        </>
    );
}
